
import { Button } from "@/components/ui/button";

interface AuthToggleProps {
  isSignUp: boolean;
  onToggle: () => void;
  loginText: string;
  registerText: string;
  alreadyHaveAccountText: string;
  dontHaveAccountText: string;
}

export const AuthToggle = ({ 
  isSignUp, 
  onToggle, 
  loginText, 
  registerText,
  alreadyHaveAccountText,
  dontHaveAccountText
}: AuthToggleProps) => {
  return (
    <div className="mt-8">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-card px-2 text-muted-foreground">
            {isSignUp ? alreadyHaveAccountText : dontHaveAccountText}
          </span>
        </div>
      </div>
      
      <div className="mt-6 text-center">
        <Button
          variant="outline"
          className="w-full border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white transition-all duration-300"
          onClick={onToggle}
        >
          {isSignUp ? loginText : registerText}
        </Button>
      </div>
    </div>
  );
};
